var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-point",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('button',{attrs:{"type":"button"}},[_vm._v("Добавить точку маршрута")])])
}
var staticRenderFns = []

export { render, staticRenderFns }